// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dragalge: PokeData = {
  "id": 691,
  "name": "dragalge",
  "height": 18,
  "weight": 815,
  "base_experience": 173,
  "types": [
    PokeType.POISON,
    PokeType.DRAGON
  ],
  "api_moves": [
    "tackle",
    "tail-whip",
    "acid",
    "water-gun",
    "hydro-pump",
    "toxic",
    "double-team",
    "smokescreen",
    "bubble",
    "feint-attack",
    "sludge-bomb",
    "outrage",
    "twister",
    "camouflage",
    "poison-tail",
    "water-pulse",
    "aqua-tail",
    "dragon-pulse",
    "dragon-tail"
  ],
  "moves": [
    "tackle",
    "acid",
    "hydro-pump",
    "bubble",
    "sludge-bomb",
    "outrage",
    "aqua-tail",
    "dragon-pulse",
    "purify",
    "dragon-claw",
    "inner-spirit",
    "toxic-spikes",
    "poison-gas"
  ],
  "evolution_chain": {
    "id": 354,
    "item": null,
    "species": [
      {
        "name": "skrelp",
        "order": 691,
        "types": [
          PokeType.POISON,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dragalge",
        "order": 692,
        "types": [
          PokeType.POISON,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 690,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 48,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 151,
    "speed": 78,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 55,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
